import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import ShipmentActions from '../../components/shipment-form/shipment-actions'
import type { DataSourceItem } from '../../shipments-page'

export const shipmentActionsColumn: ShipmentColumn = {
    key: 'shipmentActions',
    dataIndex: 'shipmentActions',
    title: '',
    fixed: 'right',
    width: 40,
    render: (_v, record: DataSourceItem) => <ShipmentActions row={record} />,
    onCell: onCellStandard,
}

